/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-form-field[_ngcontent-%COMP%]{width:100%;min-width:300px}.login-error[_ngcontent-%COMP%]{padding:16px;width:300px;color:#fff;background-color:#f44336}.login-buttons[_ngcontent-%COMP%]{margin-top:24px;display:flex;flex-direction:row;justify-content:space-between}.login-button[_ngcontent-%COMP%]{flex:.49}.links[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:flex-start}.links[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:orange}h3[_ngcontent-%COMP%]{margin-bottom:32px}"];
export { styles as styles };
